// Homepage viewport-fit utility for fixed visual stages.
// 首页视口适配工具：为固定尺寸的视觉舞台计算缩放比例。
(function () {
  'use strict';

  window.initLpViewportFit = function (section, options) {
    if (!section || !options) return null;

    var minDesktop = options.minDesktop || 769;
    var shell = section.querySelector(options.shell);
    var stage = section.querySelector(options.stage);
    var chrome = (options.chrome || []).map(function (selector) {
      return section.querySelector(selector);
    }).filter(Boolean);
    var naturalWidth = options.width;
    var naturalHeight = options.height;
    var widthReference = options.widthReference
      ? document.querySelector(options.widthReference)
      : null;
    var rafId;
    var lastScale;

    if (!shell || !stage || !naturalWidth || !naturalHeight) return null;

    function update() {
      if (window.innerWidth < minDesktop) {
        section.style.removeProperty('--fit-scale');
        lastScale = undefined;
        return;
      }

      var shellHeight = shell.clientHeight || window.innerHeight;
      var shellWidth = shell.clientWidth || window.innerWidth;
      var paddingTarget = options.paddingTarget ? section.querySelector(options.paddingTarget) : section;
      var sectionStyles = window.getComputedStyle(paddingTarget || section);
      var verticalPadding =
        (parseFloat(sectionStyles.paddingTop) || 0) +
        (parseFloat(sectionStyles.paddingBottom) || 0);
      var chromeHeight = chrome.reduce(function (total, element) {
        return total + element.offsetHeight;
      }, 0);
      var availableHeight = Math.max(120, shellHeight - verticalPadding - chromeHeight - (options.gutter || 0));
      var availableWidth = Math.max(280, shellWidth - (options.horizontalGutter || 32));
      // Keep a fitted stage within the same horizontal bounds as its shared UI reference.
      // 让自适应舞台与共享 UI 参照物保持相同的水平边界。
      if (widthReference && widthReference.clientWidth) {
        availableWidth = Math.min(availableWidth, widthReference.clientWidth);
      }
      var scale = Math.min(1, availableHeight / naturalHeight, availableWidth / naturalWidth);
      var roundedScale = Math.round(scale * 1000) / 1000;

      section.style.setProperty('--fit-scale', String(roundedScale));
      if (lastScale !== roundedScale) {
        lastScale = roundedScale;
        section.dispatchEvent(new CustomEvent('lp:viewport-fit', { detail: { scale: roundedScale } }));
      }
    }

    function scheduleUpdate() {
      window.cancelAnimationFrame(rafId);
      rafId = window.requestAnimationFrame(update);
    }

    update();
    window.requestAnimationFrame(scheduleUpdate);
    window.addEventListener('resize', scheduleUpdate, { passive: true });

    if (typeof ResizeObserver !== 'undefined') {
      new ResizeObserver(scheduleUpdate).observe(shell);
    }

    return { update: update, scheduleUpdate: scheduleUpdate };
  };
})();
